import _jsx from '@babel/runtime/helpers/esm/jsx';
import _styled, { ThemeProvider } from 'styled-components';
import { memo, useMemo } from 'react';
import { useIntl } from 'react-intl';
import EntryContent, { EntryContentHeader } from '@dbh/entry-content';
import '@dbh/generic-types';
import Image from '@dbh/image';
import Menu, { MenuItem, ID_GO_BACK, visibleHelper, invisibleHelper, MenuView, ID_ROOT_VIEW } from '@dbh/menu';
import Text from '@dbh/text';
import WelcomeBanner from '@dbh/welcome-banner';
import { TOP_MENU_HASH_VIEWS_NAMES, TOP_MENU_HASH_VIEWS, ID_TOP_MENU_HASH_PAGE, modifyTheme } from './index.js';
import { Map } from 'immutable';
import { ADMIN_IMAGES, useIconByReference } from '@dbh/images-redux';
import '@dbh/back-end-cdn-image-url-prop-type';
import { useMakeSelect } from '@dbh/reselect-extra';
import { makeSelectCurrentHashPageReference } from '@dbh/webpages-redux';
import { jsx, Fragment } from 'react/jsx-runtime';
import 'redux';
import '@dbh/entry-content-names';
import '@dbh/with-entry-content';
import '@dbh/create-use-bound-event-creator';
import '@dbh/admindev-constants';
import '@dbh/redux-extra';
import 'react-router-redux';
import 'redux-saga/effects';
import '@dbh/routing-redux';
import '@dbh/user-area-redux';
import '@dbh/navigate-to-home-page-redux';
import '@dbh/webcontrols-events-and-constants-redux';
import '@dbh/webcontrols-redux';
import 'lodash/startsWith';
import '@dbh/user-area-components';
import '@dbh/user-area-forms';
import 'reselect';
import '@dbh/admindev-types';
import '@dbh/with-conforms-to-for-production-www';
import 'lodash/trim';
import '@dbh/urls';
import 'prop-types';
import '@dbh/lodash-extra';
import 'react-immutable-proptypes';
import '@dbh/countries-redux';
import '@dbh/daybreak-hero-redux';
import 'invariant';
import '@dbh/react-lazy';
import 'react-redux';
import '@dbh/form-section-theme';

const TopMenuItem=/*#__PURE__*/memo(a=>{let{childItem:b,className:c}=a;const d=useIntl(),e=b.get("visible");if(!1===e)return null;const f=b.get("intlFormatter"),g=!!b.has("gotoIdView")&&!b.has("isBack"),h=b.get("name"),i=b.get("disabled"),j=b.get("id"),k=b.get("secondaryImageUrl"),l=b.get("url"),m=b.get("isCustomView");let n=b.get("debug")?j+": "+h:h;return f&&d&&(n=d.formatMessage({id:h},b.get("intlFormatterValues")&&b.get("intlFormatterValues").toJS())),/*#__PURE__*/_jsx(MenuItem,{gotoIdView:b.get("gotoIdView"),noFollow:b.get("noFollow"),isBack:b.has("isBack"),disabled:i,className:c,title:n,to:l,hasNextArrow:g,isCustomView:m,itemSecondaryImageUrl:k},j,n)});TopMenuItem.displayName="TopMenuItem";var TopMenuItem$1 = TopMenuItem;

const ARROW_LEFT_ICON={reference:ADMIN_IMAGES.ARROW_LEFT,firstColor:"brandFirst"},BackButton=/*#__PURE__*/memo(a=>{let{viewId:b}=a;const c=useIconByReference(ARROW_LEFT_ICON),d=useIntl(),e=useMemo(()=>{const a=Map({id:"BACK_"+b,visible:!0,isBack:!0,gotoIdView:ID_GO_BACK,secondaryImageUrl:c,name:d.formatMessage({id:"components.TopMobileMenu.back"})});return a},[b,d,c]);return/*#__PURE__*/_jsx(TopMenuItem$1,{childItem:e})});BackButton.displayName="BackButton";var TopMenuBackButton = BackButton;

const WrapperView=/*#__PURE__*/_styled.div.withConfig({componentId:"sc-gcmtw6-0"})(["",";",";"],visibleHelper,a=>!a.visible&&invisibleHelper);WrapperView.displayName="WrapperView";var WrapperView$1 = WrapperView;

const TopMenuHashViews=/*#__PURE__*/memo(a=>{let{onCloseTap:b}=a;const c=useMakeSelect(makeSelectCurrentHashPageReference),d=useMemo(()=>TOP_MENU_HASH_VIEWS_NAMES.map(a=>{const d=a===c,e=TOP_MENU_HASH_VIEWS[a];return e?/*#__PURE__*/_jsx(WrapperView$1,{visible:d},a,/*#__PURE__*/_jsx(e,{visible:d,shouldLoadChunkAndMount:d,onCloseTap:b})):null;// To preserve the animation transitions in `TopMenu` we have to wrap all the
// views with `WrapperView`; all the `TOP_MENU_HASH_VIEWS` are "universal components"
// which will be loaded "on demand".
}),[c,b]);return/*#__PURE__*/jsx(Fragment,{children:d})});TopMenuHashViews.displayName="TopMenuHashViews";var TopMenuHashViews$1 = TopMenuHashViews;

const TopMenuViews=/*#__PURE__*/memo(a=>{let{elements:b,onCloseTap:c}=a;const d=/*#__PURE__*/_jsx(MenuView,{id:ID_TOP_MENU_HASH_PAGE},"TopMenuHashViews",/*#__PURE__*/_jsx(TopMenuHashViews$1,{onCloseTap:c}));return b.reduce((a,b,c)=>{return a.push(/*#__PURE__*/// These keys are not `array` indexes but keys of an `Immutable.OrderedMap`.
// eslint-disable-next-line react/no-array-index-key
_jsx(MenuView,{id:c},c,!(c===ID_ROOT_VIEW)&&/*#__PURE__*/_jsx(TopMenuBackButton,{viewId:c}),b.map(a=>/*#__PURE__*/_jsx(TopMenuItem$1,{id:a.get("id"),analyticsEvent:a.get("analyticsEvent"),childItem:a},a.get("id"))))),a},[d])});TopMenuViews.displayName="TopMenuViews";var TopMenuViews$1 = TopMenuViews;

/*
 *
 * Component: `TopMenu`.
 *
 */var _WelcomeBanner;// the banner in this position to disappear if and when the user closes the
// same banner included just below the `NavBar` and visible in desktop
// breakpoints. The two banners are independent.
const TopMenu=/*#__PURE__*/memo(a=>{let{elements:b,visible:c,onCloseTap:d,logo:e,activeView:f,onClick:g}=a;const h=useIntl(),i=!!f&&f.get("id")===ID_ROOT_VIEW,j=f?f.get("name"):void 0;// As per business requirements, the welcome banner shall be visible only
// on the root menu.
return/*#__PURE__*/_jsx(EntryContent,{visible:c,includeDefaultHeader:!1,onClickOutside:d,centeredVertically:!0},void 0,/*#__PURE__*/_jsx(EntryContentHeader,{onCloseIconClick:d},void 0,j?/*#__PURE__*/_jsx(Text,{size:"ff5",lineHeight:"l2",weight:"bold"},void 0,j):/*#__PURE__*/_jsx(_StyledImage,{src:e.get("imageUrl"),alt:"DayBreakHotels"})),i&&(_WelcomeBanner||(_WelcomeBanner=/*#__PURE__*/_jsx(WelcomeBanner,{hideCloseButton:!0,forceVisible:!0}))),/*#__PURE__*/_jsx(Menu,{onClick:g,onCloseTap:d},void 0,/*#__PURE__*/_jsx(ThemeProvider,{theme:modifyTheme},void 0,/*#__PURE__*/_jsx(TopMenuViews$1,{idActiveView:f.get("id"),onCloseTap:d,elements:b,intl:h}))))});TopMenu.displayName="TopMenuComponent";var _StyledImage=/*#__PURE__*/_styled(Image).withConfig({componentId:"sc-1fs35yg-0"})(["width:75%;height:100%;max-width:400px;"]);

export { TopMenu as default };
